import NotFound from "@@/NotFound";
import Landing from '@@/components/Landing/LandingApp';
import BasicLayout from "@@/components/PageLayouts/BasicLayout";
import PreviewPage from "@@/pages/preview";

const indexConfig = {
    path: "/",
    element: <BasicLayout/>,
    errorElement:<NotFound/>,
    children:[
        {
            path:"/:withHeader?",
            element:<Landing/>
        },
        {
            path:"/preview/",
            element:<PreviewPage/>
        }
    ],
   
}


export default indexConfig;